var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserBgBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#A2B5BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2622 38.3024C41.0239 35.3057 38.1174 32.8724 34.7738 31.1958C31.4302 29.5193 27.7417 28.6457 24.0013 28.6445C20.2609 28.6434 16.5718 29.5146 13.2272 31.1891C9.88256 32.8636 6.97459 35.2951 4.73438 38.2904C6.9632 41.3009 9.86642 43.7472 13.2113 45.4333C16.5561 47.1194 20.2495 47.9982 23.9952 47.9994C27.741 48.0006 31.4349 47.124 34.7808 45.4401C38.1267 43.7561 41.0315 41.3115 43.2622 38.3024V38.3024Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0013 25.5484C29.1322 25.5484 33.2916 21.389 33.2916 16.2581C33.2916 11.1272 29.1322 6.96777 24.0013 6.96777C18.8704 6.96777 14.7109 11.1272 14.7109 16.2581C14.7109 21.389 18.8704 25.5484 24.0013 25.5484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBgBlack);
export default __webpack_public_path__ + "static/media/user-bg-black.dcc20e77686b6dd6f94cc6cda212f45d.svg";
export { ForwardRef as ReactComponent };